/* eslint-disable */
// Zero-touch integration for upstream `theme.js` add-to-cart behavior:
// - Patches `axios.post` (themeVendor.axios) before theme.js loads
// - Only intercepts `/cart/add.js` form-encoded requests
// - Cleans Weight + Seat Time values
// - Adds expedite line item via a second request when selected

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory();
  } else {
    const api = factory();
    const axiosGlobal = root.themeVendor && root.themeVendor.axios ? root.themeVendor.axios : root.axios;
    if (axiosGlobal) {
      api.patchAxiosCartAdd({ window: root, axios: axiosGlobal });
    }
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  function isCartAddUrl(url) {
    if (!url || typeof url !== "string") return false;
    return url.indexOf("/cart/add.js") !== -1 || url.endsWith("cart/add.js");
  }

  function isFormEncoded(config) {
    const headers = (config && config.headers) || {};
    const ct = headers["Content-Type"] || headers["content-type"] || "";
    return String(ct).indexOf("application/x-www-form-urlencoded") !== -1;
  }

  function cleanParams(windowRef, rawBody) {
    const custom = windowRef && windowRef.themeCustomValidation;
    if (custom && typeof custom.cleanFormParams === "function") {
      const params = custom.cleanFormParams(rawBody);
      return params && typeof params.toString === "function" ? params.toString() : String(rawBody || "");
    }
    // Fallback: no-op
    return String(rawBody || "");
  }

  function expediteSelectedFromParams(params) {
    if (!params || typeof params.get !== "function") return false;
    const val = params.get("properties[Expedite Build]") || "";
    return String(val).trim().toLowerCase().startsWith("yes");
  }

  function findExpediteContainer(windowRef) {
    const doc = windowRef && windowRef.document;
    const custom = windowRef && windowRef.themeCustomValidation;
    const form = custom && custom.__lastAddToCartForm ? custom.__lastAddToCartForm : null;

    if (doc && form && typeof form.getAttribute === "function") {
      const formId = form.getAttribute("id");
      if (formId && typeof doc.querySelector === "function") {
        const scopedProp = doc.querySelector(`[data-wilbers-expedite-prop][form="${formId}"]`);
        if (scopedProp && typeof scopedProp.closest === "function") {
          const c = scopedProp.closest("[data-wilbers-expedite]");
          if (c) return c;
        }
      }
      if (typeof form.querySelector === "function") {
        const c = form.querySelector("[data-wilbers-expedite]");
        if (c) return c;
      }
    }

    if (doc && typeof doc.querySelector === "function") {
      return doc.querySelector("[data-wilbers-expedite]");
    }
    return null;
  }

  function buildExpeditePayload(windowRef, quantity) {
    const container = findExpediteContainer(windowRef);
    if (!container) return null;

    const hiddenVariant =
      typeof container.querySelector === "function"
        ? container.querySelector("[data-wilbers-expedite-hidden-variant]")
        : null;
    const expediteVariantId =
      (hiddenVariant && hiddenVariant.value) ||
      (typeof container.getAttribute === "function" && container.getAttribute("data-wilbers-expedite-id")) ||
      "";
    if (!expediteVariantId) return null;

    const productTitle =
      (typeof container.getAttribute === "function" && container.getAttribute("data-wilbers-product-title")) || "";

    const params = new URLSearchParams();
    params.set("id", String(expediteVariantId));
    params.set("quantity", String(quantity || 1));
    if (productTitle) {
      params.set("properties[Product]", productTitle);
    }
    return params.toString();
  }

  function patchAxiosCartAdd({ window: windowRef, axios }) {
    const win = windowRef;
    if (!axios || typeof axios.post !== "function") return;
    if (axios.__customOrderDataCartAddPatched) return;
    axios.__customOrderDataCartAddPatched = true;

    const originalPost = axios.post.bind(axios);

    axios.post = function patchedPost(url, data, config) {
      if (!isCartAddUrl(url) || !isFormEncoded(config) || typeof data !== "string") {
        return originalPost(url, data, config);
      }

      const headersIn = (config && config.headers) || {};
      if (headersIn["X-Custom-Order-Data-Secondary"] === "1") {
        return originalPost(url, data, config);
      }

      const cleaned = cleanParams(win, data);
      const cleanedParams = new URLSearchParams(cleaned);
      const qtyRaw = cleanedParams.get("quantity");
      const qty = Math.max(1, parseInt(qtyRaw || "1", 10) || 1);
      const shouldAddExpedite = expediteSelectedFromParams(cleanedParams);

      return originalPost(url, cleaned, config).then((resp) => {
        if (!shouldAddExpedite) return resp;
        const expediteBody = buildExpeditePayload(win, qty);
        if (!expediteBody) return resp;

        const headers = Object.assign({}, headersIn);
        if (!headers["X-Requested-With"]) {
          headers["X-Requested-With"] = "XMLHttpRequest";
        }
        if (!headers["Content-Type"]) {
          headers["Content-Type"] = "application/x-www-form-urlencoded";
        }
        headers["X-Custom-Order-Data-Secondary"] = "1";

        return originalPost(url, expediteBody, { headers }).then(
          () => resp,
          () => resp
        );
      });
    };
  }

  return { patchAxiosCartAdd };
});
